var map = {
	"./Alexis.png": 4963,
	"./ISO-27001.png": 9177,
	"./ISO-27017.png": 9716,
	"./ISO-27018.png": 5011,
	"./ISO-27701.png": 5262,
	"./Iso-logo.png": 7662,
	"./Logo.png": 3286,
	"./adv.png": 5592,
	"./analyzing.gif": 5485,
	"./aws.png": 9140,
	"./azure.png": 958,
	"./bambooHr.png": 5117,
	"./breathe.png": 3228,
	"./ceridian.png": 4372,
	"./charlie.png": 853,
	"./gcp.png": 4969,
	"./google.png": 9646,
	"./loading_clock.gif": 2903,
	"./regoditWordmark.webp": 1414,
	"./soc_2.jpeg": 4114,
	"./unauthorized-person.png": 5063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1187;